import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/feed")({
  component: FeedRedirect,
});

function FeedRedirect() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const hash = window.location.hash || "";
    window.location.replace("/explore?tab=feed" + hash);
  }, []);
  return null;
}
